<app-uni-page [parent]="this" pageTitle="Reassign from Another J/O" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full p-4 gap-4 overflow-y-auto">

    <!-- STEP 1: recipient J/O search -->
    <div class="qb-detail-card qb-primary-tint p-4">
      <div class="font-semibold text-base mb-2 border-b pb-2 uppercase tracking-wide">
        Step 1: Find the Recipient J/O
      </div>
      <div class="flex items-center gap-3">
        <label for="joNumberInput" class="font-semibold">J/O Number:</label>
        <input
          #joSearchInput
          id="joNumberInput"
          pInputText
          type="text"
          inputmode="numeric"
          maxlength="7"
          autocomplete="off"
          [(ngModel)]="joNumberInput"
          (ngModelChange)="onJoNumberInputChange($event)"
          (keydown.enter)="findJoHeader()"
          title="J/O Number"
          class="w-40"
        />
        <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-search" (click)="findJoHeader()">
          <span>Search</span>
        </button>
      </div>
      <div *ngIf="selectedJoHeader" class="mt-3">
        <span class="font-semibold">Selected:</span>
        J/O {{ selectedJoHeader.id }} — {{ selectedJoHeader.account?.accountName }}
      </div>
    </div>

    <!-- STEP 2: pick a backordered recipient line -->
    <div *ngIf="selectedJoHeader && backorderedLines.length > 0" class="qb-detail-card qb-primary-tint p-4">
      <div class="font-semibold text-base mb-2 border-b pb-2 uppercase tracking-wide">
        Step 2: Pick the Backordered Line to Fill
      </div>
      <div class="max-h-96 overflow-y-auto border rounded">
        <table class="w-full text-sm">
          <thead class="sticky top-0 bg-white z-10">
            <tr class="text-left border-b">
              <th class="p-2 w-8"><span class="sr-only">Selected</span></th>
              <th class="p-2">Line #</th>
              <th class="p-2">Product</th>
              <th class="p-2 text-right">Ordered</th>
              <th class="p-2 text-right">Backordered</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let line of backorderedLines"
              class="border-b cursor-pointer hover:bg-white"
              [class.font-semibold]="selectedBackorderedLine === line"
              (click)="selectBackorderedLine(line)"
            >
              <td class="p-2">
                <i *ngIf="selectedBackorderedLine === line" class="pi pi-check text-green-700"></i>
              </td>
              <td class="p-2">{{ line.joDetail.id }}</td>
              <td class="p-2">
                {{ line.joDetail.product?.productType?.manufacturer?.name }}
                {{ line.joDetail.product?.productType?.style }}
                {{ line.joDetail.product?.featureChoicesExtract }}
              </td>
              <td class="p-2 text-right">{{ line.orderQty }}</td>
              <td class="p-2 text-right">{{ line.backorderQty }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- STEP 3: scan the donor item -->
    <div *ngIf="selectedBackorderedLine" class="qb-detail-card qb-primary-tint p-4">
      <div class="font-semibold text-base mb-2 border-b pb-2 uppercase tracking-wide">
        Step 3: Scan the Donor Item
      </div>
      <div class="text-sm text-gray-700 mb-2">
        Scan an item currently allocated to a <em>different</em> J/O. The item will move to
        this recipient J/O, and a replacement backorder will be created on the donor J/O.
      </div>
      <div class="flex items-center gap-3">
        <label for="itemBarcodeInput" class="font-semibold">Barcode:</label>
        <input
          #itemBarcodeInput
          id="itemBarcodeInput"
          pInputText
          type="text"
          inputmode="numeric"
          maxlength="12"
          autocomplete="off"
          [(ngModel)]="itemBarcodeInputValue"
          (ngModelChange)="onItemBarcodeInputChange($event)"
          (keydown.enter)="findItem()"
          title="Item Barcode"
          class="w-64"
        />
        <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-search" (click)="findItem()">
          <span>Find</span>
        </button>
      </div>
      <div *ngIf="selectedItem" class="mt-3">
        <div>
          <span class="font-semibold">Selected item:</span>
          {{ selectedItem.id }} —
          {{ selectedItem.product?.productType?.manufacturer?.name }}
          {{ selectedItem.product?.productType?.style }}
          {{ selectedItem.product?.featureChoicesExtract }}
        </div>
        <div class="text-sm mt-1">
          <span class="font-semibold">Currently on:</span>
          J/O {{ selectedItem.joDetail?.joHeaderId }} (J/O Detail {{ selectedItem.joDetailId }}),
          account {{ selectedItem.joDetail?.joHeader?.account?.accountName }}
        </div>
        <div *ngIf="isSubstitution()" class="mt-2 text-orange-700 font-semibold">
          Warning: this item's product does not match the ordered product.
          You will be asked to confirm the substitution before applying.
        </div>
        <div *ngIf="hasAppliedAddons()" class="mt-2 text-red-700 font-semibold">
          Warning: this item has been through an addon step. The physical unit may
          bear a customer-specific mark from the donor J/O. You will be asked to
          confirm before applying.
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div *ngIf="selectedJoHeader" class="flex justify-end gap-2 mt-2">
      <button pButton type="button" class="p-button-text" (click)="reset()">
        <span>Different J/O</span>
      </button>
      <button
        *ngIf="selectedBackorderedLine"
        pButton
        type="button"
        class="p-button-raised"
        icon="pi pi-check"
        [disabled]="!canApply()"
        (click)="apply()"
      >
        <span>Apply</span>
      </button>
    </div>

  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" (click)="goBack()"><span>Go Back</span></button>
  </div>
</ng-template>
